export default "__VITE_ASSET__B6Pd67Kt__"